var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientList2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "463d3b3e3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.203125 5.203125 L 369.796875 5.203125 L 369.796875 369.796875 L 5.203125 369.796875 Z M 5.203125 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3745d1051"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 5.203125 C 86.820312 5.203125 5.203125 86.820312 5.203125 187.5 C 5.203125 288.179688 86.820312 369.796875 187.5 369.796875 C 288.179688 369.796875 369.796875 288.179688 369.796875 187.5 C 369.796875 86.820312 288.179688 5.203125 187.5 5.203125 Z M 187.5 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e8ee2844a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0259423b02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.5 0.203125 C 81.820312 0.203125 0.203125 81.820312 0.203125 182.5 C 0.203125 283.179688 81.820312 364.796875 182.5 364.796875 C 283.179688 364.796875 364.796875 283.179688 364.796875 182.5 C 364.796875 81.820312 283.179688 0.203125 182.5 0.203125 Z M 182.5 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7f01d47ee"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 365,
    y: 0,
    height: 365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bff07c9ba2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180.40625 124.917969 L 288.40625 124.917969 L 288.40625 250.167969 L 180.40625 250.167969 Z M 180.40625 124.917969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b59e16f57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 114 131.179688 L 168 131.179688 L 168 185 L 114 185 Z M 114 131.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91b90d3f80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 86.582031 193 L 195.269531 193 L 195.269531 243.679688 L 86.582031 243.679688 Z M 86.582031 193 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#463d3b3e3c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3745d1051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7f01d47ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e8ee2844a4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0259423b02)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bff07c9ba2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M 182.023438 137.433594 C 182.023438 133.980469 184.8125 131.175781 188.277344 131.175781 L 282.148438 131.175781 C 285.601562 131.175781 288.40625 133.953125 288.40625 137.433594 C 288.40625 140.890625 285.613281 143.691406 282.148438 143.691406 L 188.277344 143.691406 C 184.824219 143.691406 182.023438 140.914062 182.023438 137.433594 Z M 182.023438 187.496094 C 182.023438 184.042969 184.8125 181.238281 188.277344 181.238281 L 282.148438 181.238281 C 285.601562 181.238281 288.40625 184.015625 288.40625 187.496094 C 288.40625 190.953125 285.613281 193.753906 282.148438 193.753906 L 188.277344 193.753906 C 184.824219 193.753906 182.023438 190.976562 182.023438 187.496094 Z M 182.023438 237.558594 C 182.023438 234.105469 184.8125 231.300781 188.277344 231.300781 L 282.148438 231.300781 C 285.601562 231.300781 288.40625 234.078125 288.40625 237.558594 C 288.40625 241.015625 285.613281 243.816406 282.148438 243.816406 L 188.277344 243.816406 C 184.824219 243.816406 182.023438 241.039062 182.023438 237.558594 Z M 160.121094 149.949219 C 153.207031 149.949219 147.605469 144.347656 147.605469 137.433594 C 147.605469 130.523438 153.207031 124.917969 160.121094 124.917969 C 167.03125 124.917969 172.636719 130.523438 172.636719 137.433594 C 172.636719 144.347656 167.03125 149.949219 160.121094 149.949219 Z M 160.121094 200.011719 C 153.207031 200.011719 147.605469 194.410156 147.605469 187.496094 C 147.605469 180.585938 153.207031 174.980469 160.121094 174.980469 C 167.03125 174.980469 172.636719 180.585938 172.636719 187.496094 C 172.636719 194.410156 167.03125 200.011719 160.121094 200.011719 Z M 160.121094 250.074219 C 153.207031 250.074219 147.605469 244.472656 147.605469 237.558594 C 147.605469 230.648438 153.207031 225.042969 160.121094 225.042969 C 167.03125 225.042969 172.636719 230.648438 172.636719 237.558594 C 172.636719 244.472656 167.03125 250.074219 160.121094 250.074219 Z M 160.121094 250.074219 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b59e16f57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M 140.925781 131.179688 C 148.234375 131.179688 154.851562 134.144531 159.640625 138.933594 C 164.433594 143.722656 167.394531 150.34375 167.394531 157.652344 C 167.394531 164.960938 164.433594 171.578125 159.640625 176.367188 C 154.851562 181.160156 148.234375 184.121094 140.925781 184.121094 C 133.617188 184.121094 126.996094 181.160156 122.207031 176.367188 C 117.417969 171.578125 114.453125 164.960938 114.453125 157.652344 C 114.453125 150.34375 117.417969 143.722656 122.207031 138.933594 C 126.996094 134.144531 133.617188 131.179688 140.925781 131.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91b90d3f80)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M 118.578125 193.175781 L 163.269531 193.175781 C 172.070312 193.175781 180.074219 196.773438 185.871094 202.574219 C 191.667969 208.371094 195.269531 216.371094 195.269531 225.171875 L 195.269531 242.164062 C 195.269531 243.078125 194.527344 243.820312 193.609375 243.820312 L 88.238281 243.820312 C 87.324219 243.820312 86.582031 243.078125 86.582031 242.164062 L 86.582031 225.171875 C 86.582031 216.371094 90.179688 208.371094 95.980469 202.574219 C 101.777344 196.773438 109.777344 193.175781 118.578125 193.175781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientList2);
export default __webpack_public_path__ + "static/media/ClientList2.b80da85dfc995a889ae9744cf96dc749.svg";
export { ForwardRef as ReactComponent };